const loadMore = {
    init() {
        const archives = document.querySelectorAll('.js-load-more');

        archives.forEach((archive) => {
            const grid = archive.querySelector('.js-load-more-grid');
            const button = archive.querySelector('.js-load-more-button');

            if (!grid || !button) return;

            const {category, postsPerPage} = grid.dataset;
            const postType = grid.dataset.archive;
            const total = parseInt(grid.dataset.total, 10);
            let page = parseInt(grid.dataset.paged, 10);

            const handleButtonClick = () => {
                if (page === total) {
                    return;
                }

                page += 1;

                const pageUrl = window.location.href.replace(/page\/([0-9]+)\//, '');
                window.history.replaceState(
                    null,
                    null,
                    pageUrl.replace(`/${postType}/`, `/${postType}/page/${page}/`),
                );

                button.disabled = true;

                const loadAction = 'get_ajax_news';

                fetch(window.config.ajaxUrl, {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
                    body: new URLSearchParams({
                        page,
                        cat: category ?? undefined,
                        posts_per_page: postsPerPage ?? undefined,
                        action: loadAction,
                    }),
                }).then((response) => {
                    return response.text();
                }).then((html) => {
                    grid.insertAdjacentHTML('beforeend', html);
                    button.disabled = false;

                    if (page === total) {
                        button.removeEventListener('click', handleButtonClick);
                        button.parentNode.removeChild(button);
                    }

                    window.dispatchEvent(new CustomEvent('loadMoreSuccess', {detail: postType}));
                });
            };

            button.addEventListener('click', handleButtonClick);
        })


    }
}

export default loadMore;
